import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';

import { database } from 'src/libs/firebase/firebase';
import { RealtimeLevelPrices } from 'src/type/realtime-level-price';

const REALTIME_PATH = 'product-price-logs';

/**
 * Live per-level prices from the Realtime Database node the mobile app reads,
 * so the back-office shows customers' actual prices with no polling delay.
 * `ready` turns true after the first snapshot (or a read error).
 */
export function useRealtimeLevelPrices() {
  const [prices, setPrices] = useState<RealtimeLevelPrices>({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const priceRef = ref(database, REALTIME_PATH);

    // Keep the returned unsubscribe so only this listener is removed on unmount.
    const unsubscribe = onValue(
      priceRef,
      (snapshot) => {
        setPrices((snapshot.val() as RealtimeLevelPrices | null) ?? {});
        setReady(true);
      },
      (error) => {
        console.error(`Failed to subscribe to ${REALTIME_PATH}:`, error);
        setReady(true);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return { prices, ready };
}
